import { Box, ColorOptions, ModBox, Spacer, Text } from '@jfs/ui-new'
import { FunctionComponent } from 'react'
import { ScrollView } from 'react-native'
import PaginationController from '../../../../../components/PaginationController/PaginationController'
import { useStores } from '../../../../../data/store'
import { SelectParentEntityList } from '../../../Onboarding/CreateEntity/SelectParentEntityList'
import Header from '../../TIDList/Details/Header'
import { styles } from './styles'
interface EntityListDetailsProps {
  onClose: () => void
  group: string
  subGroup: string
  entity: string
  list: any[]
  entityLevel: number
}

const columnFlexMapper: any = {
  0: 1,
  1: 1,
  2: 1,
}
const headerTitles = [{ title: 'Entity Id' }, { title: 'Business Name' }, { title: 'Status' }]
const EntityListDetails: FunctionComponent<EntityListDetailsProps> = ({
  onClose,
  group,
  subGroup,
  entity,
  list,
  entityLevel,
}: EntityListDetailsProps) => {
  const { paginationData, updatePagination } = useStores((root) => ({
    paginationData: root?.pagination,
    updatePagination: root?.updatePagination,
  }))

  const themes = styles()

  const handlePagination = (selectedPage: number) => {
    updatePagination(selectedPage)
  }
  return (
    <ScrollView stickyHeaderIndices={[0]} style={themes.container}>
      <Header type="ENTITY" tid={`L${entityLevel + 1} Entity List`} onClose={onClose} isEditMode={false} />
      <Spacer size={20} hide={false} />
      <Box flexGrow={1} marginHorizontal={40}>
        <Box direction="row" justifyContent={'space-between'} marginBottom={16}>
          <Box justifyContent={'flex-end'} alignItems={'flex-start'}>
            <ModBox
              show={group?.length > 0}
              direction="row"
              backgroundColor={'#0000000F' as ColorOptions}
              borderRadius={4}
              padding={4}
              margin={8}>
              <Text title={'Group : '} color={'BLACK_21'} fontSize={12} fontFamily={'jiotype-medium'} />
              <Text title={group ?? 'NA'} color={'BLACK_75'} fontSize={12} fontFamily={'jiotype-bold'} />
            </ModBox>
            <ModBox
              show={subGroup?.length > 0}
              direction="row"
              backgroundColor={'#0000000F' as ColorOptions}
              borderRadius={4}
              padding={4}
              margin={8}>
              <Text title={'Sub-group : '} color={'BLACK_75'} fontSize={12} fontFamily={'jiotype-medium'} />
              <Text title={subGroup ?? 'NA'} color={'BLACK_21'} fontSize={12} fontFamily={'jiotype-bold'} />
            </ModBox>
            <Box
              direction="row"
              marginBottom={32}
              backgroundColor={'#0000000F' as ColorOptions}
              borderRadius={4}
              margin={8}
              padding={4}>
              <Text title={'L1 Entity : '} color={'BLACK_75'} fontSize={12} fontFamily={'jiotype-medium'} />
              <Text title={entity} color={'BLACK_21'} fontSize={12} fontFamily={'jiotype-bold'} />
            </Box>
          </Box>
          <Box justifyContent={'flex-end'}>
            <PaginationController
              currentPage={paginationData?.number ?? 0}
              totalPages={paginationData?.totalPages ?? 0}
              totalDataLength={paginationData?.totalElements ?? 0}
              dataSetSize={paginationData?.size ?? 0}
              onSelect={handlePagination}
              isZeroIndex={false}
              defaultPage={1}
            />
          </Box>
        </Box>
        <SelectParentEntityList
          hide={false}
          title={''}
          data={list ?? []}
          columnFlexMapper={columnFlexMapper}
          headerTitles={headerTitles}
        />
      </Box>
    </ScrollView>
  )
}

export { EntityListDetails }
